<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="options[value]" /> 
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-tcc",
  props: {
    label: String,
    value: String,
  },
  data() {
    return {
      options: {
        ["Individual"]: "Individual",
        ["Dupla"]: "Dupla",
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Tcc.vue